import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useHistory, useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const Pagination = (props) => {
  const history = useHistory();
  const location = useLocation();
  const pageParam = props.pageParam;
  const items = props.items || [];
  const itemsPerPage = props.itemsPerPage || 10;

  const getPageIndexFromUrl = () => {
    if (!pageParam) return 0;
    const params = new URLSearchParams(location.search);
    const parsed = parseInt(params.get(pageParam), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed - 1 : 0;
  };

  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(
    () => getPageIndexFromUrl() * itemsPerPage,
  );

  useEffect(() => {
    if (!items.length) {
      props.setCurrentItems([]);
      setPageCount(0);
      return;
    }

    const maxPageIndex = Math.max(
      0,
      Math.ceil(items.length / itemsPerPage) - 1,
    );
    const pageIndex = Math.min(
      Math.floor(itemOffset / itemsPerPage),
      maxPageIndex,
    );
    const offset = pageIndex * itemsPerPage;

    if (offset !== itemOffset) {
      setItemOffset(offset);
      return;
    }

    props.setCurrentItems(items.slice(offset, offset + itemsPerPage));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items]);

  const updateUrlPage = (pageIndex) => {
    if (!pageParam) return;

    const params = new URLSearchParams(location.search);
    if (pageIndex <= 0) {
      params.delete(pageParam);
    } else {
      params.set(pageParam, String(pageIndex + 1));
    }

    history.replace({ search: params.toString() });
  };

  const handlePageClick = (event) => {
    if (!items.length) return;
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    updateUrlPage(event.selected);
  };

  const forcePage =
    itemsPerPage > 0 ? Math.floor(itemOffset / itemsPerPage) : 0;

  return (
    <>
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-left`}></use>
            </svg>
          }
          nextLabel={
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-right`}></use>
            </svg>
          }
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={4}
          onPageChange={handlePageClick}
          {...(pageParam ? { forcePage } : { initialPage: 0 })}
          containerClassName={"pagination justify-content-center col-12"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      )}
    </>
  );
};
export default Pagination;
